
<template>
  <div class="border border-gray-200 rounded p-4 bg-white shadow">
      <slot></slot>    
  </div>
</template>
